module.exports = __webpack_public_path__ + "img/205.61684dbe.jpg";